module.exports = __webpack_public_path__ + "static/media/accounts.5b312472.jpg";